import React from 'react';

export const HowItWorks: React.FC = () => {
    const steps = [
        {
            number: '1',
            title: 'Set Your Strategy',
            description: 'Define your own filters (e.g. TVL > $50K + APR > 200% + Pool Age < 6h)',
            risks: [
                { level: 'low', icon: '🟢', text: 'Low Risk: Blue-chip pools' },
                { level: 'medium', icon: '🟡', text: 'Medium Risk: Balanced APR' },
                { level: 'high', icon: '🔴', text: 'High Risk: Degen pools' }
            ]
        },
        {
            number: '2',
            title: 'Get Alerts or Auto-Stake',
            description: 'Telegram alerts in real-time or let NyxBot flash stake in directly with your configured payload',
            risks: []
        },
        {
            number: '3',
            title: 'Stay in Control',
            description: 'Set exit conditions, stake smaller amounts to avoid slippage, and withdraw any time',
            risks: []
        }
    ];

    return (
        <section id="how-it-works" className="py-24 bg-black">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <span className="inline-block px-6 py-3 bg-purple-500/10 border border-purple-500/30 rounded-full text-purple-300 text-lg font-semibold mb-4">
                        🧠 How NyxBot Works
                    </span>
                    <h2 className="text-5xl md:text-6xl font-bold text-white">
                        Three simple steps to{' '}
                        <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                            automated yield
                        </span>
                    </h2>
                </div>

                <div className="grid lg:grid-cols-3 gap-8">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className="relative p-8 bg-gradient-to-b from-purple-500/10 to-transparent border border-purple-500/20 rounded-2xl"
                        >
                            <div className="absolute -top-4 -left-4 w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-bold text-xl">
                                {step.number}
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-4 mt-2">{step.title}</h3>
                            <p className="text-gray-300 mb-6">{step.description}</p>
                            {step.risks.length > 0 && (
                                <div className="space-y-3">
                                    {step.risks.map((risk, riskIndex) => (
                                        <div
                                            key={riskIndex}
                                            className="flex items-center space-x-2 text-sm"
                                        >
                                            <span className="text-xl">{risk.icon}</span>
                                            <span className="text-gray-300">{risk.text}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};